import { Trans } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'row',
  },
  code: {
    marginRight: Spacing.M,
  },
})

interface Props extends ViewProps {}

const UnmatchedScreen = (props: Props) => {
  const { style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <Text level={1} style={styles.code}>
        404
      </Text>
      <Text>
        <Trans>Page not found</Trans>
      </Text>
    </View>
  )
}

export default UnmatchedScreen
